import {AlertIcon, CopilotIcon} from '@primer/octicons-react'
import {Spinner} from '@primer/react'
import {announce} from '@github-ui/aria-live'
import {useEffect} from 'react'

type FailureAnalysisStatus = 'loading' | 'empty' | 'error'

const ERROR_MESSAGE = 'Failed to load failure analysis. Try reloading the page.'

const statusConfig: Record<FailureAnalysisStatus, {icon: React.ReactNode; message: React.ReactNode}> = {
  loading: {
    icon: <Spinner size="medium" />,
    message: (
      <>
        <strong>Copilot</strong> is analyzing CI failures
      </>
    ),
  },
  empty: {
    icon: <CopilotIcon size={24} className="fgColor-muted" />,
    message: 'No failure analysis available yet.',
  },
  error: {
    icon: <AlertIcon size={24} className="fgColor-attention" />,
    message: ERROR_MESSAGE,
  },
}

export function FailureAnalysisBlankslate({status}: {status: FailureAnalysisStatus}) {
  const {icon, message} = statusConfig[status]

  useEffect(() => {
    if (status === 'error') {
      announce(ERROR_MESSAGE)
    }
  }, [status])

  return (
    <div className="p-4 d-flex flex-column flex-items-center gap-3">
      {icon}
      <span className="fgColor-muted text-small">{message}</span>
    </div>
  )
}
